import React from 'react';

const FourFingerStudiosWiki = () => {
  const handleGameClick = (gameName) => {
    window.open('https://wiki.4fingerstudios.com/', '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white p-8">
      {/* Header Section */}
      <div className="text-center mb-12">
        <h1 className="text-6xl font-bold mb-4 bg-gradient-to-r from-red-500 via-purple-500 to-blue-500 bg-clip-text text-transparent">
          4FingerStudios
        </h1>
        <p className="text-xl text-gray-400 mb-8">Independent Game Development Studio</p>
        
        {/* Studio Description */}
        <div className="max-w-4xl mx-auto bg-gray-800/50 backdrop-blur-lg rounded-2xl p-8 border border-gray-700/50">
          <p className="text-lg leading-relaxed text-gray-300">
           TEMP
          </p>
        </div>
      </div>

      {/* Games Section */}
      <div className="text-center">
        <h2 className="text-4xl font-bold mb-12 bg-gradient-to-r from-red-400 to-purple-400 bg-clip-text text-transparent">
          Our Games
        </h2>
        
        <div className="flex justify-center gap-8 flex-wrap">
          {/* Escape Protocol Button */}
          <div 
            onClick={() => handleGameClick('escape-protocol')}
            className="group relative w-72 h-48 cursor-pointer transform transition-all duration-300 hover:scale-105"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-red-900 to-black rounded-3xl border-4 border-gray-600 hover:border-red-500 transition-all duration-300 shadow-2xl group-hover:shadow-red-500/25">
              <div className="absolute inset-4 bg-gradient-to-br from-red-800/80 to-black/90 rounded-2xl flex flex-col items-center justify-center">
                <div className="text-6xl mb-2 text-red-400 group-hover:text-red-300 transition-colors">
                  ?
                </div>
                <div className="text-sm font-bold text-red-300 uppercase tracking-wider">
                  Escape Protocol
                </div>
              </div>
            </div>
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-red-500/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          </div>

          {/* Whisper of the Forgotten Button */}
          <div 
            onClick={() => handleGameClick('whisper-forgotten')}
            className="group relative w-72 h-48 cursor-pointer transform transition-all duration-300 hover:scale-105"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-purple-900 to-black rounded-3xl border-4 border-gray-600 hover:border-purple-500 transition-all duration-300 shadow-2xl group-hover:shadow-purple-500/25">
              <div className="absolute inset-4 bg-gradient-to-br from-purple-800/80 to-black/90 rounded-2xl flex flex-col items-center justify-center">
                <div className="text-6xl mb-2 text-purple-400 group-hover:text-purple-300 transition-colors">
                  ?
                </div>
                <div className="text-sm font-bold text-purple-300 uppercase tracking-wider text-center">
                  Whisper of the<br />Forgotten
                </div>
              </div>
            </div>
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-purple-500/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          </div>

          {/* Echos of Necrova Button */}
          <div 
            onClick={() => handleGameClick('echos-necrova')}
            className="group relative w-72 h-48 cursor-pointer transform transition-all duration-300 hover:scale-105"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-blue-900 to-black rounded-3xl border-4 border-gray-600 hover:border-blue-500 transition-all duration-300 shadow-2xl group-hover:shadow-blue-500/25">
              <div className="absolute inset-4 bg-gradient-to-br from-blue-800/80 to-black/90 rounded-2xl flex flex-col items-center justify-center">
                <div className="text-6xl mb-2 text-blue-400 group-hover:text-blue-300 transition-colors">
                  ?
                </div>
                <div className="text-sm font-bold text-blue-300 uppercase tracking-wider text-center">
                  Echos of<br />Necrova
                </div>
              </div>
            </div>
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-blue-500/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          </div>
        </div>

        {/* Footer */}
        <div className="mt-16 text-center">
          <p className="text-gray-500 text-sm">
            Click any game button to visit our wiki for more information
          </p>
        </div>
      </div>
    </div>
  );
};

export default FourFingerStudiosWiki;